// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  SystemConfigPage,
  SystemConfigTypePage,
  Test,
} from './';

export default {
  path: 'systemconfig',
  name: 'Systemconfig',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'type', name: 'Default page', component: SystemConfigTypePage, isIndex: true },
    { path: 'list', name: 'Default page', component: SystemConfigPage, isIndex: true },
    { path: '/test', name: 'Test', component: Test },
  ],
};



// WEBPACK FOOTER //
// ./src/features/systemconfig/route.js